import { render } from "./account-mapping-banners.vue?vue&type=template&id=675b461f&scoped=true"
import script from "./account-mapping-banners.vue?vue&type=script&lang=js"
export * from "./account-mapping-banners.vue?vue&type=script&lang=js"

import "./account-mapping-banners.vue?vue&type=style&index=0&id=675b461f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b461f"]])

export default __exports__